function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_check_icon_svg__cls-1{fill:#393c51}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_check_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_check_icon_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_check_icon_svg__cls-1",
  d: "M10 20a10 10 0 1110-10 10 10 0 01-10 10zm0-18.18A8.18 8.18 0 1018.18 10 8.19 8.19 0 0010 1.82z"
}), React.createElement("path", {
  className: "bespoken_check_icon_svg__cls-1",
  d: "M9 13.65a.91.91 0 01-.64-.27l-2.2-2.2a.91.91 0 111.29-1.29L9 11.46l3.8-3.79A.91.91 0 1114.09 9l-4.43 4.39a.91.91 0 01-.66.26z"
})));

var SvgBespokenCheckIcon = function SvgBespokenCheckIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default SvgBespokenCheckIcon;